import {fetch} from '@/utils/fetch';

/**
 *
 * @param currentPage
 * @param pageSize
 * @returns {Promise}
 */
export function getBusinessIncentives({ days }) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/business-incentives/get-bar-data`,
    method: 'get',
    params: {
      days
    }
  });
}

export function getBusinessIncentivesExcel(currentPage, pageSize) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/business-incentives/get-bar-data-excel`,
    method: 'get'
  });
}
